// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DTLK","label":"styles_label__KoVJE"};